<template>
  <div class="agility-table">
    <div
      :class="optsCopy.flexSearchBox == false ?'':'flexSearchBox'"
      v-if="optsCopy.showSearchBox != false"
    >
      <Form
        :label-width="optsCopy.labelWidth || 80"
        :model="searchBoxFormCopy"
        :ref="searchBoxRef"
        @submit.native.prevent
        label-position="right"
      >
        <div
          :style="{marginBottom: optsCopy.showBtnExt != false? '':'1rem'}"
          class="searchBox"
          v-show="expendSearchBox"
        >
          <Row style="width:100%">
            <slot name="searchBoxForm"></slot>
            <FormItem label="关键字" prop="searchKey" v-if="optsCopy.showFilter != false">
              <Input
                :size="optsCopy.size?optsCopy.size:'default'"
                @on-clear="changePage(1)"
                clearable
                placeholder="请输入关键字"
                type="text"
                v-model="searchBoxFormCopy.searchKey"
              ></Input>
            </FormItem>
            <div class="searchBoxBtns">
              <slot name="searchBoxBtns">
                <Button
                  :size="optsCopy.size?optsCopy.size:'default'"
                  @click="search"
                  type="primary"
                  v-allow="$common.operatePermission.QUERY.key"
                >查询</Button>
                <Button
                  :size="optsCopy.size?optsCopy.size:'default'"
                  @click="reset"
                  ghost
                  type="primary"
                >重置</Button>
              </slot>
              <slot name="searchBoxBtnExt"></slot>
            </div>
          </Row>
        </div>
      </Form>
      <slot name="extraContent"></slot>
      <div class="mb1 btnBox" v-if="optsCopy.showBtnExt != false">
        <div style="font-size: 0.9rem; color: #888; flex-grow: 1">
          <span v-if="optsCopy.showSelection != false">
            <Checkbox
              :indeterminate="indeterminate"
              :size="optsCopy.size?optsCopy.size:'default'"
              @on-change="changeAll"
              v-model="checkedAll"
            >全选</Checkbox>
            （已选: {{selected.length || 0}}）
          </span>
          <span class="tableDesc">
            <slot name="tableDesc"></slot>
          </span>
        </div>

        <div class="floatR">
          <Button
            @click="addFunc"
            size="small"
            type="primary"
            v-allow="$common.operatePermission.ADD.key"
            v-if="optsCopy.showAdd != false"
          >{{optsCopy.addText?optsCopy.addText:'新增'}}</Button>
          <Button
            :disabled="disabledExp"
            @click="exportAll()"
            size="small"
            type="primary"
            v-allow="$common.operatePermission.EXPORT.key"
            v-if="optsCopy.exportUrl"
          >{{optsCopy.exportText?optsCopy.exportText:'导出'}}</Button>
          <slot name="tableBtnExt"></slot>
          <Button
            @click="delFunc"
            size="small"
            type="error"
            v-allow="$common.operatePermission.DELETE.key"
            v-if="optsCopy.showMultiDel"
          >{{optsCopy.multiDelText?optsCopy.multiDelText:'批量刪除'}}</Button>
          <Button
            @click="setColumns"
            ghost
            size="small"
            type="primary"
            v-allow="$common.operatePermission.QUERY.key"
            v-if="optsCopy.showCloumSetting"
          >列设置</Button>
          <Button
            @click="expendForm"
            size="small"
            type="primary"
            v-if="optsCopy.showExpend != false"
          >{{this.expendSearchBox? '收起':'展开'}}</Button>
        </div>
      </div>
      <slot name="tableExtraContent"></slot>
    </div>

    <div class="contentBox">
      <template v-if="opts.type == 'tree'">
        <Table
          :border="optsCopy.border"
          :columns="curColumns"
          :data="data"
          :highlight-row="optsCopy.highlightRow"
          :loading="loading"
          :ref="agilityTableRef"
          :row-class-name="optsCopy.rowClassName"
          :row-key="optsCopy.rowKey?optsCopy.rowKey:'id'"
          :show-summary="optsCopy.showSummary || false"
          :size="optsCopy.size?optsCopy.size:'default'"
          :stripe="optsCopy.stripe"
          :sum-text="optsCopy.sumText || '合计'"
          @on-sort-change="sortPage"
          key="id"
        >
          <template :slot="name" slot-scope="row" v-for="name in (optsCopy.slots || [])">
            <slot :name="name" :row="row"></slot>
          </template>
        </Table>
      </template>
      <template v-else-if="opts.type == 'item'">
        <CheckboxGroup @on-change="itemChange" style="width: 100%" v-model="itemSelected">
          <div class="pageItemBox">
            <template v-if="data && data.length > 0">
              <div
                :key="pageItem.id"
                :style="{width: (optsCopy.radio || 25) + '%', minWidth: (optsCopy.radio || 25) + '%'}"
                class="pageItemContainer"
                v-for="pageItem in data"
              >
                <div class="pageItem">
                  <div class="pageItemLabelContainer" v-if="optsCopy.showSelection != false">
                    <Checkbox :label="pageItem.id">
                      <span></span>
                    </Checkbox>
                  </div>
                  <slot :item="pageItem" name="pageItemContent"></slot>
                </div>
              </div>
            </template>
            <div class="noData" v-else>暂无数据</div>
          </div>
        </CheckboxGroup>
      </template>

      <template v-else-if="opts.type == 'self'">
        <slot name="tableSelf"></slot>
      </template>
      <Table
        :border="optsCopy.border"
        :columns="curColumns"
        :data="data"
        :draggable="optsCopy.draggable || false"
        :highlight-row="optsCopy.highlightRow"
        :loading="loading"
        :ref="agilityTableRef"
        :row-class-name="optsCopy.rowClassName"
        :show-summary="optsCopy.showSummary || false"
        :size="optsCopy.size?optsCopy.size:'default'"
        :stripe="optsCopy.stripe"
        :sum-text="optsCopy.sumText || '合计'"
        @on-current-change="currentChange"
        @on-drag-drop="dragDrop"
        @on-select="selectCurrentOpts"
        @on-select-all-cancel="cancelAll"
        @on-select-cancel="cancelSelect"
        @on-selection-change="selectionChildren"
        @on-sort-change="sortPage"
        key="id"
        v-else
      >
        <template :slot="name" slot-scope="row" v-for="name in (optsCopy.slots || [])">
          <slot :name="name" :row="row"></slot>
        </template>
      </Table>
      <div class="textR mt1" style="    position: relative;">
        <Page
          :current="curPage.pageNo"
          :page-size="curPage.pageSize"
          :page-size-opts="curPage.pageSizeOpts"
          :show-elevator="isPc && curPage.pageable != false"
          :show-sizer="isPc && curPage.pageable != false"
          :show-total="isPc"
          :simple="!isPc"
          :size="optsCopy.size?optsCopy.size:'default'"
          :total="curPage.total"
          @on-change="changePage"
          @on-page-size-change="changePageSize"
          transfer
          v-if="curPage.pageable != false"
        ></Page>
        <!-- <div class="ivu-page" v-else>
          <div class="ivu-page-total" style="font-size: 0.85rem">共{{curPage.total}}条</div>
        </div>-->
      </div>
    </div>
    <Drawer title="列设置" v-model="showSettings" width="500px">
      <div class="drawerBody">
        <div class="drawerContent">
          <div class="columnsSetting">
            <Checkbox
              :indeterminate="indeterminateColumns"
              :value="checkedAllColumns"
              @on-change="handleCheckAll"
            >全选</Checkbox>
            <Button @click="resetColumns" ghost size="small" type="primary">重置</Button>
          </div>
          <CheckboxGroup
            @on-change="checkAllGroupChange"
            ref="columnsCheck"
            v-model="checkAllGroup"
          >
            <div
              :key="baseColumn.key"
              style="line-height: 2.2rem;"
              v-for="baseColumn in baseColumns"
            >
              <Checkbox :key="baseColumn.key" :label="baseColumn.key">{{baseColumn.title}}</Checkbox>
            </div>
          </CheckboxGroup>
        </div>
      </div>
    </Drawer>
  </div>
</template>
<script>
export default {
  name: 'agilityTable',
  props: {
    searchBoxForm: {
      required: false,
      default: () => {
        return {
          searchKey: ''
        }
      }
    },
    columns: {
      required: false,
      default: () => {
        return []
      }
    },
    opts: {},
    page: {},
    disabledExp: false
  },
  watch: {
    searchBoxForm: {
      handler (newValue, oldValue) {
        console.log('newValue', newValue)
        console.log('oldValue', oldValue)
        this.searchBoxFormCopy = Object.assign({}, this.searchBoxForm)
        // 参数改变时 是否自动查询
        if (this.optsCopy.autoSearch != false) {
          console.log('autoSearch')
          this.search()
        }
      },
      deep: true,
      immediate: true
    },
    columns: {
      handler (newValue, oldValue) {
        // this.handlerColum()
        this.baseColumns = Object.assign([], newValue)
      },
      deep: true,
      immediate: true
    },
    opts: {
      handler (newValue, oldValue) {
        console.log('opts newValue', newValue)
        console.log('opts oldValue', oldValue)
        console.log(JSON.stringify(newValue) != JSON.stringify(oldValue))
        if (JSON.stringify(newValue) != JSON.stringify(oldValue)) {
          this.optsCopy = Object.assign({}, newValue)
          this.search()
        }
      },
      deep: true,
      immediate: true
    },
  },
  data () {
    return {
      expendSearchBox: true,
      optsCopy: {},
      agilityTableRef: 'agilityTable-' + (new Date()).getTime(),
      searchBoxRef: 'searchBox-' + (new Date()).getTime(),
      loading: false,
      data: [],
      indeterminate: false,
      checkedAll: false,
      selected: [],
      itemSelected: [],
      curPage: {
        pageSize: this.$common.page.pageSize,
        pageSizeOpts: this.$common.page.pageSizeOpts,
        total: 0,
        pageNo: 1,
        sorts: {}
      },
      searchBoxFormCopy: {},
      showSettings: false,
      indeterminateColumns: false,
      checkedAllColumns: false,
      checkAllGroup: [],
      baseColumns: []
    }
  },
  computed: {
    isPc: function () {
      return this.$store.getters['systemInfo/isPc'] || true
    },
    curColumns: function () {
      let columnsCopy = []
      if (this.optsCopy.showCloumSetting) {
        if (this.optsCopy.type != "tree") {
          if (this.optsCopy.showSelection != false) {
            {
              columnsCopy = [
                {
                  type: 'selection',
                  width: 60,
                  align: 'center',
                  fixed: "left",
                }]
            }
          }
          if (this.optsCopy.showIndex) {
            columnsCopy.push(
              {
                width: 80,
                align: "center",
                fixed: "left",
                title: "序号",
                key: "index",
                render: (h, params) => {
                  return h('span', params.index + (this.curPage.pageNo - 1) * this.curPage.pageSize + 1)
                }
              })
          }
          // if (this.optsCopy.showSelection != false && Object.keys(this.optsCopy).length != 0) {
          //   columnsCopy = [
          //     {
          //       type: 'selection',
          //       width: 60,
          //       align: 'center',
          //       fixed: "left",
          //     }]
          // } else {
          //   columnsCopy = [{
          //     width: 80,
          //     align: "center",
          //     fixed: "left",
          //     title: "序号",
          //     key: "index",
          //     render: (h, params) => {
          //       return h('span', params.index + (this.curPage.pageNo - 1) * this.curPage.pageSize + 1)
          //     }
          //   }]
          // }

        }
        let exist = this.baseColumns.filter(column => {
          if (this.checkAllGroup.indexOf(column.key) >= 0) {
            return true
          }
          return false
        })
        columnsCopy = columnsCopy.concat(exist)
      } else {
        if (this.optsCopy.type == "tree") {
          columnsCopy = []
        } else {
          if (this.optsCopy.showSelection != false && Object.keys(this.optsCopy).length != 0) {
            columnsCopy = [
              {
                type: 'selection',
                width: 60,
                align: 'center',
                fixed: "left",
              },
            ]
          }

          if (this.optsCopy.showIndex) {
            columnsCopy.push(
              {
                width: 80,
                align: "center",
                fixed: "left",
                title: "序号",
                key: "index",
                render: (h, params) => {
                  return h('span', params.index + (this.curPage.pageNo - 1) * this.curPage.pageSize + 1)
                }
              })
          }
        }
        this.columns.forEach(col => {
          if (Object.keys(col).length > 0) columnsCopy.push(col)
        })
      }
      return columnsCopy
    }
  },
  methods: {
    expendForm: function () {
      this.expendSearchBox = !this.expendSearchBox
    },
    handleCheckAll: function (status) {
      this.checkAllGroup = []
      if (status) {
        this.baseColumns.forEach(element => {
          this.checkAllGroup.push(element.key)
        })
        this.indeterminateColumns = false
        this.checkedAllColumns = true
      } else {
        this.indeterminateColumns = false
        this.checkedAllColumns = false
      }
    },
    setColumns: function () {
      this.showSettings = !this.showSettings
    },
    resetColumns: function () {
      this.checkAllGroupChange(Object.assign([], this.optsCopy.defaultChecked))
    },
    setColumns: function () {
      this.showSettings = !this.showSettings
    },
    checkAllGroupChange: function (selected) {
      this.checkAllGroup = selected
      let totalSize = this.baseColumns.length
      if (selected.length === totalSize && selected.length > 0) {
        this.indeterminateColumns = false
        this.checkedAllColumns = true
      } else if (selected.length > 0) {
        this.indeterminateColumns = true
        this.checkedAllColumns = false
      } else {
        this.indeterminateColumns = false
        this.checkedAllColumns = false
      }
    },
    changeAll: function (status) {
      this.checkedAll = status
      if (this.optsCopy.type == 'item') {
        this.itemSelected = []
        if (status) {
          this.selected = Object.assign([], this.data)
          this.selected.forEach(ele => this.itemSelected.push(ele.id))
        } else {
          this.selected = []
        }
      } else {
        if (this.$refs[this.agilityTableRef]) this.$refs[this.agilityTableRef].selectAll(status)
      }

      if (!status) {
        this.checkedAll = false
        this.indeterminate = false
      } else {
        this.checkedAll = true
        this.indeterminate = false
      }
    },
    cancelSelect: function (currentChecked, cancel) {
      this.$emit('addFunc', 'cancelSelect', { cancel: cancel, currentChecked: currentChecked })
    },
    selectCurrentOpts: function (checked, currentChecked) {
      this.$emit('addFunc', 'selectCurrentOpts', { checked: checked, currentChecked: currentChecked })
    },
    cancelAll: function (data) {
      this.$emit('addFunc', 'cancelAll', data)
    },
    currentChange: function (current, prev) {
      this.$emit('addFunc', 'currentChange', { current, prev })
    },
    dragDrop: function (index1, index2) {
      let config = Object.assign([], data)
      // 修改位置的元素
      let item = config[index1]
      // 删除元素
      config.splice(index1, 1)
      if (index2 != 0) {
        // 原数组长度改变了 下标-1
        index2 = index2 - 1
      }
      config.splice(index2, 0, item)
      data = config
      this.$emit('dragDrop', { index1, index2 })
    },
    selectionChildren: function (selected) {
      this.selected = selected
      let len = this.data.length
      if (selected.length === len && selected.length > 0) {
        this.indeterminate = false
        this.checkedAll = true
      } else if (selected.length > 0) {
        this.indeterminate = true
        this.checkedAll = false
      } else {
        this.indeterminate = false
        this.checkedAll = false
      }
      let data = {}
      data.all = this.data.map(ele => ele.id)
      data.selected = selected.map(ele => ele.id)
      this.$emit('on-select-change', data)
    },
    itemChange: function (selected) {
      this.itemSelected = selected
      this.selected = this.data.filter(ele => this.itemSelected.indexOf(ele.id) >= 0)
      let len = this.data.length
      if (selected.length === len && selected.length > 0) {
        this.indeterminate = false
        this.checkedAll = true
      } else if (selected.length > 0) {
        this.indeterminate = true
        this.checkedAll = false
      } else {
        this.indeterminate = false
        this.checkedAll = false
      }
    },
    sortPage: function (params) {
      this.curPage.sorts = { key: params.key, order: params.order }
      this.curPage.pageNo = 1
      this.initTable()
    },
    changePage: function (val) {
      this.curPage.pageNo = val
      this.initTable()
    },
    changePageSize: function (val) {
      this.curPage.pageSize = val
      this.curPage.pageNo = 1
      this.initTable()
    },
    initTable: function () {
      if (this.optsCopy.searchUrl) {
        let _this = this
        this.changeAll(false)
        _this.loading = true
        _this.data = []
        let pageParams = this.$common.getPageParams(this.columns, Object.assign({}, this.curPage), this.searchBoxFormCopy.searchKey)
        pageParams.pageable = this.curPage.pageable != undefined ? this.curPage.pageable : true
        let params = new this.$URLSearchParams()
        params.append("pageParams", JSON.stringify(pageParams))
        params.append("searchData", JSON.stringify(this.searchBoxFormCopy))
        this.$axios.post(_this.optsCopy.searchUrl, params, { baseURL: this.optsCopy.baseURL || process.env.VUE_APP_API_ROOT }).then(res => {
          if (res.success) {
            _this.curPage.total = res.result?.total || 0
            _this.data = res.result?.data || []
            _this.data.forEach(element => {
              if (element.whenUpdated) element.whenUpdated = _this.$common.getDate(element.whenUpdated)
              if (element.whenCreated) element.whenCreated = _this.$common.getDate(element.whenCreated)
            })
          } else {
            _this.$Message.error({
              content: res.message,
              duration: 3
            })
          }
        }).catch(function (err) {
          _this.$Message.error({
            content: '数据获取失败！',
            duration: 3
          })
        }).finally(val => {
          let params = {}
          params.page = Object.assign({}, this.curPage)
          params.searchBoxForm = Object.assign({}, this.searchBoxFormCopy)
          sessionStorage.setItem(this.$route.name, JSON.stringify(params))
          _this.$emit('addFunc', 'dataChange')
          _this.loading = false
        })
      }
    },
    search: function () {
      this.curPage = Object.assign({}, this.page)
      this.initTable()
    },
    reset: function () {
      if (Object.keys(this.searchBoxForm).length == 1 && Object.keys(this.searchBoxForm).filter(key => 'searchKey' == key).length > 0) {
        if (this.$refs[this.searchBoxRef]) this.$refs[this.searchBoxRef].resetFields()
        this.searchBoxFormCopy = Object.assign({}, this.searchBoxForm)
        this.search()
      } else {
        this.$emit('addFunc', 'reset')
        this.$nextTick(() => {
          this.search()
        })
      }
    },
    addFunc: function () {
      this.$emit('addFunc', 'add')
    },
    viewFunc: function (data) {
      console.log(data)
      this.$emit('addFunc', 'view', data)
    },
    exportAll: function () {
      let that = this
      if (this.curPage.total == 0) {
        this.$Message.warning({ content: '暂无可导出数据！', duration: 5 })
        return
      }
      let params = new this.$URLSearchParams()
      let content = '请确认是否导出全部数据！'
      if (this.selected && this.selected.length > 0) {
        let ids = []
        this.selected.forEach(item => {
          ids.push(item.id)
        })
        params.append("ids", ids)
        content = `请确认是否导出选中的${this.selected.length}条数据！`
      } else if (this.curPage.total > 60000) {
        this.$Message.warning({ content: '当前记录超过6万条，请添加筛选条件后下载！', duration: 5 })
        return
      }
      this.$Modal.confirm({
        title: '提醒',
        content: content,
        okText: '导出',
        onOk: () => {
          this.$Spin.show({
            render: (h) => {
              return h('div', [
                h('Icon', {
                  'class': 'demo-spin-icon-load',
                  props: {
                    type: 'ios-loading',
                    size: 18
                  }
                }),
                h('div', '文件下载中，请稍后...')
              ])
            }
          })

          let config = { responseType: 'blob' }
          if (this.optsCopy.baseURL) config.baseURL = this.optsCopy.baseURL
          let pageParams = this.$common.getPageParams(this.columns, Object.assign({}, this.curPage), this.searchBoxFormCopy.searchKey)
          pageParams.pageable = false
          params.append("pageParams", JSON.stringify(pageParams))
          params.append("searchData", JSON.stringify(this.searchBoxFormCopy))
          that.$axios.post(that.optsCopy.exportUrl, params, config).then(res => {
            let url = window.URL.createObjectURL(new Blob([res.data]))
            let link = document.createElement('a')
            link.style.display = 'none'
            link.href = url
            if (that.optsCopy.name) {
              link.download = that.optsCopy.name
            } else {
              if (res.headers['content-disposition']) {
                link.download = decodeURI(res.headers['content-disposition'].split('=')[1])
              } else {
                link.download = new Date()
              }
            }
            document.body.appendChild(link)
            link.click()
            window.URL.revokeObjectURL(link.href)
            document.body.removeChild(link)
          }).catch(function (err) {
            console.log("exportAll error", err)
            that.$Message.error('导出失败！')
          }).finally(() => {
            that.$Spin.hide()
          })
        }
      })
    },
    delOneFunc: function (data) {
      if (data) {
        this.delByIds([data.id])
      } else {
        this.$Message.warning(`请选择要${this.optsCopy.delText || '删除'}的数据！`)
      }
    },
    delFunc: function () {
      if (this.selected && this.selected.length > 0) {
        let ids = []
        this.selected.forEach(item => {
          ids.push(item.id)
        })
        this.delByIds(ids)
      } else {
        this.$Message.warning(`请选择要${this.optsCopy.delText || '删除'}的数据！`)
      }
    },
    delByIds: function (ids) {
      let that = this
      let text = this.optsCopy.delText || '删除'
      this.$Modal.confirm({
        title: '提醒',
        content: `请确认是否${text}数据！`,
        okText: text,
        onOk: () => {
          this.$Spin.show({
            render: (h) => {
              return h('div', [
                h('Icon', {
                  'class': 'demo-spin-icon-load',
                  props: {
                    type: 'ios-loading',
                    size: 18
                  }
                }),
                h('div', text + '中，请稍后...')
              ])
            }
          })
          let params = new this.$URLSearchParams()
          params.append("ids", ids)
          that.$axios.post(that.optsCopy.delUrl, params, { baseURL: this.optsCopy.baseURL || process.env.VUE_APP_API_ROOT }).then(res => {
            if (res.success) {
              that.$Message.success(`${this.optsCopy.delText || '删除'}成功！`)
              that.changeAll(false)
              that.changePage(1)
              that.$emit('addFunc', 'del')
            } else {
              that.$Message.error(res.message)
            }
          }).catch(function (err) {
            console.log(err)
            that.$Message.error(`${that.optsCopy.delText || '删除'}失败！`)
          }).finally(() => {
            that.$Spin.hide()
          })
        }
      })
    },

  },
  beforeMount () {
    this.optsCopy = Object.assign({}, this.opts)
    this.curPage = Object.assign({}, this.page)
    if (this.optsCopy.showCloumSetting) {
      this.checkAllGroup = Object.assign([], this.optsCopy.defaultChecked)
      // this.baseColumns = Object.assign([], this.cloumns)
      this.indeterminateColumns = true
    }
    // this.search()
  }
}
</script>
<style lang='less' scoped>
.agility-table {
  width: 100%;
  min-height: 100%;

  .contentBox {
    /* border-top: 1px solid #dcdee2; */
    padding: 0;
  }

  .btnBox {
    line-height: 3rem;
    /* height: 3rem; */
    /* border-top: 1px solid #dcdee2; */
    border-bottom: 1px dashed #dcdee2;
    margin-bottom: 1rem;
    position: sticky;
    top: 0;
    /* z-index: 999; */
    padding: 0 5px;
    display: flex;
    justify-content: space-between;
  }

  .columnsSetting {
    border-bottom: 1px solid #ddd;
    padding: 0.5rem 0;
    display: flex;
    align-items: baseline;
    justify-content: space-between;
  }

  .pageItemBox {
    position: relative;
    display: flex;
    flex-wrap: wrap;
  }

  .pageItemBox .pageItemContainer {
    /* flex: 1; */
    max-width: 50%;
    /* min-width: 25%; */
    min-width: fit-content;
    padding: 10px;
    overflow: hidden;
    position: relative;
  }

  .pageItemBox .pageItemContainer .pageItem {
    border: 1px solid #e8e8e8;
    background: #fff;
    border-radius: 2px;
    text-align: center;
    height: 100%;
    display: flex;
    flex-direction: column;
    position: relative;
  }

  .noData {
    text-align: center;
    width: 100%;
    margin: 1rem;
    font-size: 0.85rem;
    color: #666;
  }

  .pageItemLabelContainer {
    z-index: 98;
    width: 100%;
    text-align: left;
    padding: 2px 5px;
  }
  .tableDesc {
    /* margin-left: 25%; */
  }
}
</style>